import styled from "styled-components";

export const Edu = styled.div``;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: var(--grayWhite);
  margin-bottom: 40px;
`;

export const EduRow = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EduItm = styled.div`
  padding: 40px;
  position: relative;
  border-left: 2px solid var(--black);
  border-bottom: 0.5px solid var(--black);

  &:before {
    position: absolute;
    content: "";
    border-color: transparent transparent transparent var(--black);
    border-style: solid;
    border-width: 10px 12px;
    left: -1px;
    top: 64px;
  }
  h4 {
    color: var(--black);
  }
  span {
    display: inline-block;
    padding: 0 10px;
    color: var(--accent-green);
  }
  a {
    color: var(--black);
    svg {
      width: 14px;
      height: 14px;
    }
  }
  p {
    font-size: 14px;
    color: var(--grayWhite);
    line-height: 1.5;
  }
`;
